import { render, staticRenderFns } from "./OximetryCreation.vue?vue&type=template&id=6f5d88e3&scoped=true"
import script from "./OximetryCreation.vue?vue&type=script&lang=js"
export * from "./OximetryCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5d88e3",
  null
  
)

export default component.exports